import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/candidate',
    authDomain: 'login.staging.seek.com',
    clientDomain: 'www.staging.seek.com.au',
    clientId: 'wibHYTQFO7tynJZT0nO4xmxTj02Jn47W',
    environment: 'dev',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    brand: Brand.SEEK,
    contactUs: {
        en: 'https://www.seek.com.au/contact-us/',
    },
    siteName: siteNames.candidate.seek.au,
    zone: getZoneFromSite(siteNames.candidate.seek.au),
    product: Product.SEEK,
};
//# sourceMappingURL=staging_seek_com_au.js.map